// extracted by mini-css-extract-plugin
export default {"wrapper":"Faq_wrapper_e0O1Y","h1":"Faq_h1_puqUN","section":"Faq_section_SRmix","h2":"Faq_h2_oWCMB","accordion":"Faq_accordion_eE7BT","p":"Faq_p_kvEEg"};